import { storage } from './usePersistState';

const buildHeader = (config) => {
  const headers = {};
  if (config?.session) {
    const user_session = storage.get('user-session');
    headers.Authorization = `Bearer ${user_session.token}`;
  }
  return headers;
};

const api = {
  get: async (url, config) => {
    try {
      let params = '';
      if (config?.params) {
        params = `?${new URLSearchParams(config?.params).toString()}`;
      }
      const headers = buildHeader(config);
      const raw = await fetch(
        `${process.env.REACT_APP_END_POINT}${url}${params}`,
        {
          headers,
        }
      );
      const res = await raw.json();

      if (raw.status !== 200) {
        return {
          error: true,
          data: res,
        };
      }
      if (typeof config?.transform === 'function') {
        return config.transform(res);
      }
      return res;
    } catch (err) {
      console.log(err);
      return { error: true, data: err };
    }
  },
  post: async (url, config) => {
    try {
      const headers = buildHeader(config);
      const raw = await fetch(`${process.env.REACT_APP_END_POINT}${url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...headers,
        },
        body: JSON.stringify(config?.payload || {}),
      });
      const res = await raw.json();
      if (raw.status >= 300) {
        return {
          error: true,
          data: res,
        };
      }
      if (typeof config?.transform === 'function') {
        return config.transform(res);
      }
      return res;
    } catch (err) {
      return { error: true, data: err };
    }
  },
  remove: async (url, config) => {
    try {
      const headers = buildHeader(config);
      const raw = await fetch(`${process.env.REACT_APP_END_POINT}${url}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          ...headers,
        },
        body: JSON.stringify(config?.payload || {}),
      });
      const res = await raw.json();
      if (raw.status >= 300) {
        return {
          error: true,
          data: res,
        };
      }
      if (typeof config?.transform === 'function') {
        return config.transform(res);
      }
      return res;
    } catch (err) {
      return { error: true, data: err };
    }
  },
};

export default api;
